import {useQuery} from "react-query";
import request from "../../../shared/request";


export const useGetUsers = () => {

    return useQuery(['users'], () => request({
        url: `/api/users`
    }))
}